import {
  Dialog,
  DialogActions,
  DialogContent,
  Zoom,
} from "@mui/material";
import { Button } from "Atoms";

const DeletePopUp = (props:any) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      TransitionComponent={Zoom}
      fullWidth
    >
      <DialogContent
        id="alert-dialog-description"
        className="delete-dialog-content"
      sx={{padding:"5%"}}
      >
        Are you sure to delete ?
      </DialogContent>
      <DialogActions  sx={{padding:"5%"}}>
        <Button onClick={props.handleClose} variant="outlined" >
          no
        </Button>
        <Button onClick={props.handleDelete} variant="outlined" color="error" >
          yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeletePopUp;
